import { apiRoutes } from 'config/apiRoutes'
import { useAxiosPrivate } from 'shared/hooks'

export const usePrintPayout = () => {
	const axiosPrivate = useAxiosPrivate()

	const printPayout = (id: number) => {
		axiosPrivate.get(apiRoutes.payoutPrint(id)).then((response) => {
			const receiptUrl = URL.createObjectURL(new Blob([response.data], { type: 'text/html' }))

			window.open(receiptUrl)
		})
	}

	return { printPayout }
}
